import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LandingNav } from '../components/Nav';
import SiteFooter from '../components/SiteFooter';

export default function Contact() {
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [topic, setTopic] = useState('General');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [sent, setSent] = useState(false);

  const CONTACT_EMAIL = 'vanessa@orivonai.com';

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim());
  }

  function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setSent(false);

    if (!name.trim()) return setError('Please enter your name.');
    if (!isValidEmail(email)) return setError('Please enter a valid email.');
    if (!message.trim() || message.trim().length < 10) return setError('Please write a message (at least 10 characters).');

    const subject = `OrivonAI Contact — ${topic}`;
    const body = [
      `Name: ${name}`,
      `Email: ${email}`,
      `Topic: ${topic}`,
      '',
      message.trim(),
      '',
      '— Sent from the OrivonAI contact form',
    ].join('\n');

    const mailto = `mailto:${encodeURIComponent(CONTACT_EMAIL)}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.location.href = mailto;
    setSent(true);
  }

  return (
    <div style={{ minHeight: '100vh', background: 'var(--sand)' }}>
      <div style={{ background: 'var(--white)' }}>
        <LandingNav />
      </div>

      <section style={{ padding: '64px 48px' }}>
        <div style={{ maxWidth: 720, margin: '0 auto' }}>
          <p style={{ textAlign: 'center', fontSize: 11, fontWeight: 700, letterSpacing: '.12em', textTransform: 'uppercase', color: 'var(--muted)', marginBottom: 10 }}>
            Contact
          </p>
          <h2 className="serif" style={{ fontFamily: 'Playfair Display,serif', fontSize: 36, textAlign: 'center', color: 'var(--text)', marginBottom: 10, letterSpacing: '-.3px', lineHeight: 1.3 }}>
            Get in touch
          </h2>
          <p style={{ textAlign: 'center', fontSize: 14, color: 'var(--muted)', maxWidth: 520, margin: '0 auto 36px', lineHeight: 1.7 }}>
            Questions, feedback, partnerships, or support ideas. Email us at{' '}
            <a href={`mailto:${CONTACT_EMAIL}`} style={{ color: 'var(--pink)', fontWeight: 700, textDecoration: 'none' }}>
              {CONTACT_EMAIL}
            </a>
            .
          </p>

          <form onSubmit={handleSubmit} style={{ background: 'var(--card)', border: '1px solid var(--border)', borderRadius: 14, padding: 20 }}>
            {error && <div style={{ fontSize: 13, color: '#b91c1c', marginBottom: 14 }}>{error}</div>}

            {sent && (
              <div style={{ fontSize: 13, color: 'var(--sage-d)', marginBottom: 14, fontWeight: 700 }}>
                Opening your email client with your message…
              </div>
            )}

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
              <label style={{ display: 'block' }}>
                <div style={{ fontSize: 12, fontWeight: 700, color: 'var(--text)', marginBottom: 6 }}>Name</div>
                <input
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="Your name"
                  style={{ width: '100%', fontSize: 14, border: '1.5px solid var(--border)', borderRadius: 10, padding: '12px 14px', background: 'var(--white)', color: 'var(--text)', outline: 'none' }}
                />
              </label>

              <label style={{ display: 'block' }}>
                <div style={{ fontSize: 12, fontWeight: 700, color: 'var(--text)', marginBottom: 6 }}>Email</div>
                <input
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@example.com"
                  inputMode="email"
                  style={{ width: '100%', fontSize: 14, border: '1.5px solid var(--border)', borderRadius: 10, padding: '12px 14px', background: 'var(--white)', color: 'var(--text)', outline: 'none' }}
                />
              </label>
            </div>

            <label style={{ display: 'block', marginTop: 14 }}>
              <div style={{ fontSize: 12, fontWeight: 700, color: 'var(--text)', marginBottom: 6 }}>Topic</div>
              <select
                value={topic}
                onChange={(e) => setTopic(e.target.value)}
                style={{ width: '100%', fontSize: 14, border: '1.5px solid var(--border)', borderRadius: 10, padding: '12px 14px', background: 'var(--white)', color: 'var(--text)', outline: 'none' }}
              >
                <option>General</option>
                <option>Support</option>
                <option>Partnerships</option>
                <option>Feedback</option>
              </select>
            </label>

            <label style={{ display: 'block', marginTop: 14 }}>
              <div style={{ fontSize: 12, fontWeight: 700, color: 'var(--text)', marginBottom: 6 }}>Message</div>
              <textarea
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Write your message…"
                rows={6}
                style={{ width: '100%', fontSize: 14, border: '1.5px solid var(--border)', borderRadius: 10, padding: '12px 14px', background: 'var(--white)', color: 'var(--text)', outline: 'none', resize: 'vertical' }}
              />
            </label>

            <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', marginTop: 18, alignItems: 'center' }}>
              <button type="button" className="btn-ghost" onClick={() => navigate('/')} style={{ fontWeight: 800 }}>
                ← Back To Home
              </button>
              <button type="submit" className="btn-primary" style={{ boxShadow: 'none', fontWeight: 800 }}>
                Send Message
              </button>
            </div>
          </form>
        </div>
      </section>

      <SiteFooter />
    </div>
  );
}

